// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 320px) {

  .container {
    max-width: 320px;
  }
}
@media (min-width: 512px) {

  .container {
    max-width: 512px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1281px) {

  .container {
    max-width: 1281px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-\\[170px\\] {
  left: 170px;
}
.left-\\[37px\\] {
  left: 37px;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.right-5 {
  right: 1.25rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-\\[-24px\\] {
  top: -24px;
}
.top-\\[-39px\\] {
  top: -39px;
}
.top-\\[4\\.5rem\\] {
  top: 4.5rem;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[4\\] {
  z-index: 4;
}
.z-\\[99999999999999999\\] {
  z-index: 99999999999999999;
}
.z-\\[99\\] {
  z-index: 99;
}
.float-end {
  float: inline-end;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.\\!mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.\\!my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5 {
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-my-1\\.5 {
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-14 {
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-20 {
  margin-left: 5rem;
  margin-right: 5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[1\\.5em\\] {
  margin-bottom: 1.5em;
}
.mb-\\[1\\.75em\\] {
  margin-bottom: 1.75em;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[24px\\] {
  margin-bottom: 24px;
}
.mb-\\[30px\\] {
  margin-bottom: 30px;
}
.mb-\\[50px\\] {
  margin-bottom: 50px;
}
.mb-\\[7px\\] {
  margin-bottom: 7px;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-20 {
  margin-left: 5rem;
}
.ml-\\[-50px\\] {
  margin-left: -50px;
}
.ml-\\[35px\\] {
  margin-left: 35px;
}
.ml-\\[3em\\] {
  margin-left: 3em;
}
.mr-4 {
  margin-right: 1rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-28 {
  margin-top: 7rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[6rem\\] {
  margin-top: 6rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[10vh\\] {
  height: 10vh;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[135px\\] {
  height: 135px;
}
.h-\\[136px\\] {
  height: 136px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[148px\\] {
  height: 148px;
}
.h-\\[158px\\] {
  height: 158px;
}
.h-\\[20vh\\] {
  height: 20vh;
}
.h-\\[23vh\\] {
  height: 23vh;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[25vh\\] {
  height: 25vh;
}
.h-\\[26vh\\] {
  height: 26vh;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30vh\\] {
  height: 30vh;
}
.h-\\[323px\\] {
  height: 323px;
}
.h-\\[340px\\] {
  height: 340px;
}
.h-\\[38vh\\] {
  height: 38vh;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[40vh\\] {
  height: 40vh;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[483px\\] {
  height: 483px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[50vh\\] {
  height: 50vh;
}
.h-\\[515px\\] {
  height: 515px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[66vh\\] {
  height: 66vh;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[85px\\] {
  height: 85px;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[95\\%\\] {
  height: 95%;
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-12 {
  max-height: 3rem;
}
.max-h-\\[210px\\] {
  max-height: 210px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.min-h-\\[20vh\\] {
  min-height: 20vh;
}
.w-0 {
  width: 0px;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[1140px\\] {
  width: 1140px;
}
.w-\\[1240px\\] {
  width: 1240px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[16rem\\] {
  width: 16rem;
}
.w-\\[173px\\] {
  width: 173px;
}
.w-\\[191px\\] {
  width: 191px;
}
.w-\\[19rem\\] {
  width: 19rem;
}
.w-\\[20\\] {
  width: 20;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[215px\\] {
  width: 215px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[30\\.5\\%\\] {
  width: 30.5%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[34\\%\\] {
  width: 34%;
}
.w-\\[344px\\] {
  width: 344px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[432px\\] {
  width: 432px;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[50vw\\] {
  width: 50vw;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[62\\%\\] {
  width: 62%;
}
.w-\\[69\\%\\] {
  width: 69%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[853px\\] {
  width: 853px;
}
.w-\\[85px\\] {
  width: 85px;
}
.w-\\[88\\%\\] {
  width: 88%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[92\\%\\] {
  width: 92%;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[15rem\\] {
  min-width: 15rem;
}
.min-w-\\[550px\\] {
  min-width: 550px;
}
.min-w-\\[750px\\] {
  min-width: 750px;
}
.max-w-12 {
  max-width: 3rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[1140px\\] {
  max-width: 1140px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[28rem\\] {
  max-width: 28rem;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[1_1_45\\%\\] {
  flex: 1 1 45%;
}
.flex-\\[2_2_55\\%\\] {
  flex: 2 2 55%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.origin-center {
  transform-origin: center;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[270deg\\] {
  --tw-rotate: 270deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.18\\] {
  --tw-scale-x: 1.18;
  --tw-scale-y: 1.18;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-\\[-1\\] {
  --tw-scale-y: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[29px\\] {
  gap: 29px;
}
.gap-\\[35\\%\\] {
  gap: 35%;
}
.gap-\\[40px\\] {
  gap: 40px;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-12 {
  column-gap: 3rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-7 {
  column-gap: 1.75rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.gap-y-14 {
  row-gap: 3.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-20 {
  row-gap: 5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[0\\.10px\\] {
  border-width: 0.10px;
}
.border-\\[0\\.8px\\] {
  border-width: 0.8px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[1\\.9px\\] {
  border-width: 1.9px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1\\.5px\\] {
  border-bottom-width: 1.5px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[3px\\] {
  border-top-width: 3px;
}
.border-solid {
  border-style: solid;
}
.border-dotted {
  border-style: dotted;
}
.border-\\[\\#0270b9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(2 112 185 / var(--tw-border-opacity));
}
.border-\\[\\#1e85be\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 133 190 / var(--tw-border-opacity));
}
.border-\\[\\#AD3511\\] {
  --tw-border-opacity: 1;
  border-color: rgb(173 53 17 / var(--tw-border-opacity));
}
.border-\\[\\#DDDDDD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity));
}
.border-\\[\\#ED4D19\\] {
  --tw-border-opacity: 1;
  border-color: rgb(237 77 25 / var(--tw-border-opacity));
}
.border-\\[\\#d1d1d1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
}
.border-\\[\\#e3e3e3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(227 227 227 / var(--tw-border-opacity));
}
.border-\\[grey\\] {
  --tw-border-opacity: 1;
  border-color: rgb(128 128 128 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-b-\\[\\#C73F13\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(199 63 19 / var(--tw-border-opacity));
}
.border-b-black {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-t-\\[\\#DDDDDD\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(221 221 221 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#DD4824\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(221 72 36 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#0170B9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 112 185 / var(--tw-bg-opacity));
}
.bg-\\[\\#0170b9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 112 185 / var(--tw-bg-opacity));
}
.bg-\\[\\#0270B9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 112 185 / var(--tw-bg-opacity));
}
.bg-\\[\\#048500\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 133 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#478603\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(71 134 3 / var(--tw-bg-opacity));
}
.bg-\\[\\#AD3511\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(173 53 17 / var(--tw-bg-opacity));
}
.bg-\\[\\#CA0000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(202 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#CC4114\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 65 20 / var(--tw-bg-opacity));
}
.bg-\\[\\#D59292\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(213 146 146 / var(--tw-bg-opacity));
}
.bg-\\[\\#EFEFEF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity));
}
.bg-\\[\\#e11111\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(225 17 17 / var(--tw-bg-opacity));
}
.bg-\\[\\#ebebeb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
}
.bg-\\[\\#ededed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 237 / var(--tw-bg-opacity));
}
.bg-\\[\\#f2f2f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f5f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity));
}
.bg-\\[\\#f7f6f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 246 247 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-cover {
  background-size: cover;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-current {
  fill: currentColor;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-32 {
  padding-left: 8rem;
  padding-right: 8rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[40px\\] {
  padding-left: 40px;
  padding-right: 40px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[50px\\] {
  padding-top: 50px;
  padding-bottom: 50px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-40 {
  padding-bottom: 10rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pb-\\[50px\\] {
  padding-bottom: 50px;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-\\[10px\\] {
  padding-left: 10px;
}
.pl-\\[50px\\] {
  padding-left: 50px;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-11 {
  padding-top: 2.75rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.font-\\[\\'Montserrat\\'\\2c Sans-serif\\] {
  font-family: 'Montserrat',Sans-serif;
}
.font-\\[\\'poppins\\'\\2c Sans-serif\\] {
  font-family: 'poppins',Sans-serif;
}
.font-blinkcofo {
  font-family: "Blinkcofo", sans-serif;
}
.font-roboto {
  font-family: Roboto, Sans-serif;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-simonetta {
  font-family: Simonetta, sans-serif;
}
.\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[1em\\] {
  font-size: 1em;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[31px\\] {
  font-size: 31px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[34px\\] {
  font-size: 34px;
}
.text-\\[35px\\] {
  font-size: 35px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[38px\\] {
  font-size: 38px;
}
.text-\\[42px\\] {
  font-size: 42px;
}
.text-\\[50px\\] {
  font-size: 50px;
}
.text-\\[52px\\] {
  font-size: 52px;
}
.text-\\[55px\\] {
  font-size: 55px;
}
.text-\\[60px\\] {
  font-size: 60px;
}
.text-\\[64px\\] {
  font-size: 64px;
}
.text-\\[70px\\] {
  font-size: 70px;
}
.text-\\[90px\\] {
  font-size: 90px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-bold {
  font-weight: 700 !important;
}
.font-\\[300\\] {
  font-weight: 300;
}
.font-\\[580\\] {
  font-weight: 580;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-extralight {
  font-weight: 200;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.2em\\] {
  line-height: 1.2em;
}
.leading-\\[1\\.3em\\] {
  line-height: 1.3em;
}
.leading-\\[1em\\] {
  line-height: 1em;
}
.leading-\\[2\\.2em\\] {
  line-height: 2.2em;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-\\[\\#000002\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 2 / var(--tw-text-opacity));
}
.text-\\[\\#1C244B\\] {
  --tw-text-opacity: 1;
  color: rgb(28 36 75 / var(--tw-text-opacity));
}
.text-\\[\\#1C244b\\] {
  --tw-text-opacity: 1;
  color: rgb(28 36 75 / var(--tw-text-opacity));
}
.text-\\[\\#1c244b\\] {
  --tw-text-opacity: 1;
  color: rgb(28 36 75 / var(--tw-text-opacity));
}
.text-\\[\\#1e85be\\] {
  --tw-text-opacity: 1;
  color: rgb(30 133 190 / var(--tw-text-opacity));
}
.text-\\[\\#324A6D\\] {
  --tw-text-opacity: 1;
  color: rgb(50 74 109 / var(--tw-text-opacity));
}
.text-\\[\\#3A3A3A\\] {
  --tw-text-opacity: 1;
  color: rgb(58 58 58 / var(--tw-text-opacity));
}
.text-\\[\\#3a3a3a\\] {
  --tw-text-opacity: 1;
  color: rgb(58 58 58 / var(--tw-text-opacity));
}
.text-\\[\\#4B4F58\\] {
  --tw-text-opacity: 1;
  color: rgb(75 79 88 / var(--tw-text-opacity));
}
.text-\\[\\#515151\\] {
  --tw-text-opacity: 1;
  color: rgb(81 81 81 / var(--tw-text-opacity));
}
.text-\\[\\#545058\\] {
  --tw-text-opacity: 1;
  color: rgb(84 80 88 / var(--tw-text-opacity));
}
.text-\\[\\#545454\\] {
  --tw-text-opacity: 1;
  color: rgb(84 84 84 / var(--tw-text-opacity));
}
.text-\\[\\#555961\\] {
  --tw-text-opacity: 1;
  color: rgb(85 89 97 / var(--tw-text-opacity));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.text-\\[\\#6D6D6D\\] {
  --tw-text-opacity: 1;
  color: rgb(109 109 109 / var(--tw-text-opacity));
}
.text-\\[\\#AD3511\\] {
  --tw-text-opacity: 1;
  color: rgb(173 53 17 / var(--tw-text-opacity));
}
.text-\\[\\#C03C12\\] {
  --tw-text-opacity: 1;
  color: rgb(192 60 18 / var(--tw-text-opacity));
}
.text-\\[\\#C70000\\] {
  --tw-text-opacity: 1;
  color: rgb(199 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#C73F13\\] {
  --tw-text-opacity: 1;
  color: rgb(199 63 19 / var(--tw-text-opacity));
}
.text-\\[\\#E02424\\] {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity));
}
.text-\\[\\#ED4D19\\] {
  --tw-text-opacity: 1;
  color: rgb(237 77 25 / var(--tw-text-opacity));
}
.text-\\[\\#a50000\\] {
  --tw-text-opacity: 1;
  color: rgb(165 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#e02424\\] {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity));
}
.text-\\[\\#ec3a3a\\] {
  --tw-text-opacity: 1;
  color: rgb(236 58 58 / var(--tw-text-opacity));
}
.text-\\[\\#ff0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-black\\/70 {
  color: rgb(0 0 0 / 0.7);
}
.text-black\\/80 {
  color: rgb(0 0 0 / 0.8);
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-600::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(75 85 99 / var(--tw-placeholder-opacity));
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-\\[\\.6\\] {
  opacity: .6;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}




body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Simonetta', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.swiper-button-prev {
  height: 100% !important;

  top: 0 !important;
  
  
}

.swiper-button-next {
  height: 100% !important;
  top: 0 !important;
  right: 0 !important;
 
}

.swiper-pagination {
  margin-top: 10px !important;
  position: relative !important;
}

.swiper-pagination-bullet {
  height: 12px !important;
  width: 12px !important;
}

.swiper-pagination-bullet-active {
  background-color: #4cadb2 !important;
}

.swiper-button-next:after {
  font-size: 18px !important;
  font-weight: bolder !important;
  width: 20%;
  color: #9a9a9add !important;
 

}

.swiper-button-prev:after   {
  font-size: 18px !important;
  font-weight: 900 !important;
  color: #9a9a9add !important;
  width: 20%;
  
}


.swiper-button-prev, .swiper-rtl .swiper-button-next {
  left: unset !important;
  right: auto;
}




.multi-range-slider {
  border: none !important;
  border-radius: 0px !important;
  box-shadow: none !important;
}

.bar-left , .bar-right {
  padding: 4px 0px !important;
  border: 1px solid !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.face:hover {
  animation: shake 0.3s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}


@keyframes shake {
  0% { transform: translate(1px, 0px) rotate(0deg); }
  20% { transform: translate(-2px, 0px) rotate(-2deg); }
  40% { transform: translate(1px, 0px) rotate(0deg); }
  60% { transform: translate(-2px, 0px) rotate(-2deg); }
  80% { transform: translate(1px, 0px) rotate(0deg); }
  100% { transform: translate(-2px, 0px) rotate(-2deg); }
}
@keyframes shakeDice {
  0% { transform: translate(1px, 0px) rotate(0deg); }
  10% { transform: translate(1px, 0px) rotate(0deg); }
  20% { transform: translate(-2px, 0px) rotate(-2deg); }
  30% { transform: translate(1px, 0px) rotate(0deg); }
  40% { transform: translate(1px, 0px) rotate(0deg); }
  60% { transform: translate(-2px, 0px) rotate(-2deg); }
  80% { transform: translate(1px, 0px) rotate(0deg); }
  100% { transform: translate(-2px, 0px) rotate(-2deg); }
}

.dice:hover {
  animation: shakeDice 0.5s cubic-bezier(.36,.07,.19,.97) both infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.zoom {

  transition: transform .2s; /* Animation */
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(1.1);

  
}
.zoomImgae{
  transition: transform .2s; /* Animation */


}
.zoomImgae:hover{
  transform: scale(1.1);

}
.brand-image {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.fade-in {
  opacity: 1;
}

.fade-out {
  opacity: 0;
}
.active.link{
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.element-icon {
  fill: red;
}


.labels {
  display: none !important;
}

/* ImageComponent.css */
@keyframes elementor-animation-pop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.zoom-in-out-box {
  transition: transform 0.3s linear;
}

.zoom-in-out-box:hover {
  animation: elementor-animation-pop 0.3s linear 1;
}



/* .zoom-in-out-box:hover {
  margin: 10px;
  width: 50px;
  height: 10px;

  animation: zoom-in-zoom-out 1s ease infinite;
} */

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}

.Background-fixed {
  Background-image: url( https://www.w3schools.com/howto/img_parallax.jpg);
  background-attachment: fixed;
  background-position: center;
  position: relative;
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
}

.ImageInnerWrap {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 100px;
}

.scrol {
  scrollbar-width: thin;
  scrollbar-color: #6d6c6c #404040;
}


#img-zoom {
  transition: transform 0.5s ease; /* Smooth transition */

}

.cart-background-image {
  height: 330px !important;
}

.cart-heading {
  background-color: rgb(0 0 0 / 0.5);
  font-weight: 600;
}

.table-product-row {
  font-size: 15px !important;
}



.container {
  width: 100%;
}
@media (min-width: 320px) {
  .container {
      max-width: 400px;
  }
}
@media (min-width: 512px) {
  .container {
      max-width: 512px;
  }
}
@media (min-width: 640px) {
  .container {
      max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
      max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
      max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
      max-width: 1120px;
  }
}
@media (min-width: 1281px) {
  .container {
    max-width: 1140px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1250px;
  }
}


.home {
  width: 100%;
}
@media (min-width: 320px) {
  .home {
      max-width: 400px;
  }
}
@media (min-width: 512px) {
  .home {
      max-width: 512px;
  }
}
@media (min-width: 640px) {
  .home {
      max-width: 640px;
  }
}
@media (min-width: 768px) {
  .home {
      max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .home {
      max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .home {
      max-width: 1120px;
  }
}
@media (min-width: 1281px) {
  .home {
    max-width: 1340px;
  }
}
@media (min-width: 1536px) {
  .home {
    max-width: 1250px;
  }
}
@media(max-width:1100px){
  .backgroundSetting{
  background-size:200% 100% !important
  }
}

#img-zoom:hover {
  animation: zoomInOut 0.9s ease forwards infinite;
}

@keyframes zoomInOut {
  0% {
    transform: scale(1); /* Start at normal size */
  }
 
  50% {
    transform: scale(1.2); /* Zoom in to 1.2 */
  }
 
  100% {
    transform: scale(1); /* Then zoom out to 0.9 */
  }
}
#icon-zoom {
  transition: transform 0.5s ease; /* Smooth transition */

}

#icon-zoom:hover {
  animation: zoomInOuticon 0.9s ease forwards infinite;
}

@keyframes zoomInOuticon {
  0% {
    transform: scale(1); /* Start at normal size */
  }
 
  50% {
    transform: scale(1.15); /* Zoom in to 1.2 */
  }
 
  100% {
    transform: scale(0.9); /* Then zoom out to 0.9 */
  }
}

.imageChange {
  Background-image: url( https://technostorage.nyc3.digitaloceanspaces.com/uploads/2021/11/pointing-female.png) !important;
}

/* retailerComission image hover effects */

.img-hover-effect {
  transition: transform 0.3s ease; /* Adding transition to both default and hover states */
}

.img-hover-effect:hover {
  transform: scale(1.1) rotate(4deg);
}

.left-retailer-effect {
  transition: transform 0.3s cubic-bezier(.47,2.02,.31,-.36);
}

.left-retailer-effect:hover {
  transform: scale(1.2);
}

.active.link{
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.nest-wrapper  .nested-ul   ul {   
display: none;
  } 

  
.nest-wrapper:hover  .nested-ul   ul {   
display: flex;
    }

  .loader {
      border: 16px solid #f3f3f3;
      border-radius: 50%;
      border-top: 16px solid #AD3511;
      width: 50px;
      height: 50px;
      padding:15px; /* Safari */
      animation: spin 2s linear infinite;
    }
    
    /* Safari */
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

.PLoader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #AD3511;
  width: 100px;
  height: 100px;
  padding:15px; /* Safari */
  animation: spin 2s linear infinite;
}

.image-container {
  position: relative;
  overflow: hidden;
}

.image-zoom {
  transition: transform 0.3s;
  transform-origin: center center;
  pointer-events: none;
}

.image-container:hover .image-zoom {
  transform: scale(1.5);
  pointer-events: auto;
}


.buttonLoader{
    width: 45px;
    padding: 6px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #ffffff;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    mask: var(--_m);
    mask-composite: subtract;
    animation: l3 1s infinite linear;
    margin: auto;
  }
  @keyframes l3 {to{transform: rotate(1turn)}}

  .Loader{
    width: 45px;
    padding: 6px;

    aspect-ratio: 1;
    border-radius: 50%;
    background: #E02424;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    mask: var(--_m);
    mask-composite: subtract;
    animation: l3 1s infinite linear;
    margin: auto;
  }
  @keyframes l3 {to{transform: rotate(1turn)}}


  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .products-container {
    display: grid;
    gap: 20px;
    justify-items: center;
  }
  
  .product-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .product-image {
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
  }
  
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .product-name {
    font-family: "Poppins", Sans-serif;
    font-size: 22px;
    font-weight: 600;
    text-transform: capitalize;
    font-style: normal;
    text-decoration: none;
    line-height: 1.2em;
    letter-spacing: 0;
    text-align: left;
  }
  
  .product-price {
    color: #1C244B;
    font-family: "Poppins", Sans-serif;
    font-size: 16px;
    font-weight: 300;
    text-transform: none;
    font-style: normal;
    text-decoration: none;
    line-height: 1.5em;
    letter-spacing: 0;
    text-align: left;
  }
  
  .product-button {
    color: #1C244B;
    background-color: #fff0;
    font-family: "Poppins", Sans-serif;
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    font-style: italic;
    text-decoration: underline;
    line-height: 1em;
    letter-spacing: 0;
    padding: 10px 0 0 0;
    margin-top: 0;
    text-align: left;
  }
  
  .product-button:hover {
    color: #467FF7;
    
  }
  
  .before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
  
  .before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
  
  .before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}
  
  .before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}
  
  .before\\:block::before {
  content: var(--tw-content);
  display: block;
}
  
  .before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}
  
  .before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}
  
  .before\\:bg-red-700::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
  
  .before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  
  .before\\:duration-300::before {
  content: var(--tw-content);
  transition-duration: 300ms;
}
  
  .hover\\:cursor-not-allowed:hover {
  cursor: not-allowed;
}
  
  .hover\\:overflow-visible:hover {
  overflow: visible;
}
  
  .hover\\:border:hover {
  border-width: 1px;
}
  
  .hover\\:border-\\[\\#C70000\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(199 0 0 / var(--tw-border-opacity));
}
  
  .hover\\:border-black:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
  
  .hover\\:border-blue-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
  
  .hover\\:bg-\\[\\#0170b9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(1 112 185 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-\\[\\#3A3A3A\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 58 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-\\[\\#3f3f3f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 63 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-\\[\\#ededed\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 237 237 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
  
  .hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
  
  .hover\\:text-\\[\\#0170b9\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(1 112 185 / var(--tw-text-opacity));
}
  
  .hover\\:text-\\[\\#C70000\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(199 0 0 / var(--tw-text-opacity));
}
  
  .hover\\:text-\\[\\#e82a00\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(232 42 0 / var(--tw-text-opacity));
}
  
  .hover\\:text-\\[\\#ff0000\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
  
  .hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
  
  .hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
  
  .hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
  
  .hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
  
  .hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
  
  .hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
  
  .hover\\:text-green-400:hover {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
  
  .hover\\:text-green-500:hover {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
  
  .hover\\:text-green-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
  
  .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
  
  .hover\\:shadow-gray-900\\/20:hover {
  --tw-shadow-color: rgb(17 24 39 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
  
  .hover\\:before\\:w-full:hover::before {
  content: var(--tw-content);
  width: 100%;
}
  
  .focus\\:border:focus {
  border-width: 1px;
}
  
  .focus\\:border-2:focus {
  border-width: 2px;
}
  
  .focus\\:border-dotted:focus {
  border-style: dotted;
}
  
  .focus\\:border-\\[\\#3d24249a\\]:focus {
  border-color: #3d24249a;
}
  
  .focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
  
  .focus\\:bg-transparent:focus {
  background-color: transparent;
}
  
  .focus\\:opacity-\\[0\\.85\\]:focus {
  opacity: 0.85;
}
  
  .focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  
  .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  
  .focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity));
}
  
  .active\\:text-\\[\\#e82a00\\]:active {
  --tw-text-opacity: 1;
  color: rgb(232 42 0 / var(--tw-text-opacity));
}
  
  .active\\:opacity-\\[0\\.85\\]:active {
  opacity: 0.85;
}
  
  .active\\:shadow-none:active {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
  
  .disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
  
  .disabled\\:bg-slate-400:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
  
  .disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
  
  .disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .group:hover .group-hover\\:h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
  
  .group:hover .group-hover\\:py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
  
  @media (min-width: 640px) {

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-relaxed {
    line-height: 1.625;
  }
}
  
  @media (min-width: 768px) {

  .md\\:flex {
    display: flex;
  }

  .md\\:w-\\[39rem\\] {
    width: 39rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
  
  @media (min-width: 1024px) {

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-9xl {
    font-size: 8rem;
    line-height: 1;
  }
}
  
  @media (max-width: 670px) {

  .medium\\:hidden {
    display: none;
  }

  .medium\\:w-\\[100\\%\\] {
    width: 100%;
  }
}
  
  @media (max-width: 512px) {

  .mobile\\:m-4 {
    margin: 1rem;
  }

  .mobile\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .mobile\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .mobile\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .mobile\\:mt-2 {
    margin-top: 0.5rem;
  }

  .mobile\\:block {
    display: block;
  }

  .mobile\\:hidden {
    display: none;
  }

  .mobile\\:\\!h-\\[14rem\\] {
    height: 14rem !important;
  }

  .mobile\\:\\!h-\\[60vh\\] {
    height: 60vh !important;
  }

  .mobile\\:h-\\[20vh\\] {
    height: 20vh;
  }

  .mobile\\:h-\\[229px\\] {
    height: 229px;
  }

  .mobile\\:h-\\[40vh\\] {
    height: 40vh;
  }

  .mobile\\:\\!w-full {
    width: 100% !important;
  }

  .mobile\\:w-1\\/2 {
    width: 50%;
  }

  .mobile\\:w-\\[234px\\] {
    width: 234px;
  }

  .mobile\\:w-full {
    width: 100%;
  }

  .mobile\\:\\!max-w-full {
    max-width: 100% !important;
  }

  .mobile\\:\\!grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .mobile\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .mobile\\:flex-col {
    flex-direction: column;
  }

  .mobile\\:\\!items-start {
    align-items: flex-start !important;
  }

  .mobile\\:items-center {
    align-items: center;
  }

  .mobile\\:\\!justify-center {
    justify-content: center !important;
  }

  .mobile\\:justify-center {
    justify-content: center;
  }

  .mobile\\:gap-y-2 {
    row-gap: 0.5rem;
  }

  .mobile\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .mobile\\:gap-y-4 {
    row-gap: 1rem;
  }

  .mobile\\:object-contain {
    object-fit: contain;
  }

  .mobile\\:\\!px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .mobile\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .mobile\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .mobile\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .mobile\\:text-center {
    text-align: center;
  }

  .mobile\\:\\!text-5xl {
    font-size: 3rem !important;
    line-height: 1 !important;
  }

  .mobile\\:\\!text-\\[22px\\] {
    font-size: 22px !important;
  }

  .mobile\\:\\!text-\\[25px\\] {
    font-size: 25px !important;
  }

  .mobile\\:\\!text-\\[30px\\] {
    font-size: 30px !important;
  }

  .mobile\\:\\!text-\\[40px\\] {
    font-size: 40px !important;
  }

  .mobile\\:\\!text-\\[50px\\] {
    font-size: 50px !important;
  }

  .mobile\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .mobile\\:text-\\[30px\\] {
    font-size: 30px;
  }
}
  
  @media (max-width: 768px) {

  .smallTablet\\:absolute {
    position: absolute;
  }

  .smallTablet\\:left-0 {
    left: 0px;
  }

  .smallTablet\\:top-\\[2\\.5rem\\] {
    top: 2.5rem;
  }

  .smallTablet\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .smallTablet\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .smallTablet\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .smallTablet\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .smallTablet\\:ml-0 {
    margin-left: 0px;
  }

  .smallTablet\\:mr-0 {
    margin-right: 0px;
  }

  .smallTablet\\:mt-2 {
    margin-top: 0.5rem;
  }

  .smallTablet\\:mt-3 {
    margin-top: 0.75rem;
  }

  .smallTablet\\:mt-6 {
    margin-top: 1.5rem;
  }

  .smallTablet\\:block {
    display: block;
  }

  .smallTablet\\:flex {
    display: flex;
  }

  .smallTablet\\:hidden {
    display: none;
  }

  .smallTablet\\:\\!h-\\[90px\\] {
    height: 90px !important;
  }

  .smallTablet\\:h-\\[100px\\] {
    height: 100px;
  }

  .smallTablet\\:h-\\[109px\\] {
    height: 109px;
  }

  .smallTablet\\:h-\\[12vh\\] {
    height: 12vh;
  }

  .smallTablet\\:h-\\[15rem\\] {
    height: 15rem;
  }

  .smallTablet\\:h-\\[200px\\] {
    height: 200px;
  }

  .smallTablet\\:h-\\[201px\\] {
    height: 201px;
  }

  .smallTablet\\:h-\\[205px\\] {
    height: 205px;
  }

  .smallTablet\\:h-\\[20vh\\] {
    height: 20vh;
  }

  .smallTablet\\:h-\\[220px\\] {
    height: 220px;
  }

  .smallTablet\\:h-\\[25vh\\] {
    height: 25vh;
  }

  .smallTablet\\:h-\\[30vh\\] {
    height: 30vh;
  }

  .smallTablet\\:h-\\[35vh\\] {
    height: 35vh;
  }

  .smallTablet\\:h-\\[400px\\] {
    height: 400px;
  }

  .smallTablet\\:h-\\[50\\%\\] {
    height: 50%;
  }

  .smallTablet\\:h-\\[65px\\] {
    height: 65px;
  }

  .smallTablet\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .smallTablet\\:h-\\[80px\\] {
    height: 80px;
  }

  .smallTablet\\:h-\\[90px\\] {
    height: 90px;
  }

  .smallTablet\\:h-auto {
    height: auto;
  }

  .smallTablet\\:h-full {
    height: 100%;
  }

  .smallTablet\\:\\!w-\\[95\\%\\] {
    width: 95% !important;
  }

  .smallTablet\\:\\!w-full {
    width: 100% !important;
  }

  .smallTablet\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .smallTablet\\:w-\\[3\\%\\] {
    width: 3%;
  }

  .smallTablet\\:w-\\[60px\\] {
    width: 60px;
  }

  .smallTablet\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .smallTablet\\:w-auto {
    width: auto;
  }

  .smallTablet\\:w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .smallTablet\\:w-full {
    width: 100%;
  }

  .smallTablet\\:\\!min-w-full {
    min-width: 100% !important;
  }

  .smallTablet\\:\\!max-w-full {
    max-width: 100% !important;
  }

  .smallTablet\\:\\!grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .smallTablet\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .smallTablet\\:flex-col {
    flex-direction: column;
  }

  .smallTablet\\:\\!items-center {
    align-items: center !important;
  }

  .smallTablet\\:items-center {
    align-items: center;
  }

  .smallTablet\\:\\!justify-center {
    justify-content: center !important;
  }

  .smallTablet\\:justify-center {
    justify-content: center;
  }

  .smallTablet\\:gap-y-14 {
    row-gap: 3.5rem;
  }

  .smallTablet\\:gap-y-20 {
    row-gap: 5rem;
  }

  .smallTablet\\:gap-y-4 {
    row-gap: 1rem;
  }

  .smallTablet\\:bg-scroll {
    background-attachment: scroll;
  }

  .smallTablet\\:object-fill {
    object-fit: fill;
  }

  .smallTablet\\:\\!px-\\[20px\\] {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .smallTablet\\:\\!py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .smallTablet\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .smallTablet\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .smallTablet\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .smallTablet\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .smallTablet\\:pl-4 {
    padding-left: 1rem;
  }

  .smallTablet\\:text-center {
    text-align: center;
  }

  .smallTablet\\:\\!text-4xl {
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }

  .smallTablet\\:\\!text-6xl {
    font-size: 3.75rem !important;
    line-height: 1 !important;
  }

  .smallTablet\\:\\!text-\\[18px\\] {
    font-size: 18px !important;
  }

  .smallTablet\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .smallTablet\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .smallTablet\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .smallTablet\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .smallTablet\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .smallTablet\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .smallTablet\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .smallTablet\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .smallTablet\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .smallTablet\\:text-\\[50px\\] {
    font-size: 50px;
  }

  .smallTablet\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .smallTablet\\:font-bold {
    font-weight: 700;
  }
}
  
  @media (max-width: 1024px) {

  .tablet\\:mt-6 {
    margin-top: 1.5rem;
  }

  .tablet\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .tablet\\:hidden {
    display: none;
  }

  .tablet\\:h-\\[110px\\] {
    height: 110px;
  }

  .tablet\\:h-\\[35\\%\\] {
    height: 35%;
  }

  .tablet\\:h-auto {
    height: auto;
  }

  .tablet\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .tablet\\:w-\\[355px\\] {
    width: 355px;
  }

  .tablet\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .tablet\\:w-\\[65\\%\\] {
    width: 65%;
  }

  .tablet\\:w-auto {
    width: auto;
  }

  .tablet\\:w-full {
    width: 100%;
  }

  .tablet\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .tablet\\:flex-col {
    flex-direction: column;
  }

  .tablet\\:justify-start {
    justify-content: flex-start;
  }

  .tablet\\:justify-center {
    justify-content: center;
  }

  .tablet\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }

  .tablet\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .tablet\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .tablet\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .tablet\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .tablet\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .tablet\\:px-\\[50px\\] {
    padding-left: 50px;
    padding-right: 50px;
  }

  .tablet\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .tablet\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .tablet\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .tablet\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .tablet\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .tablet\\:text-\\[23px\\] {
    font-size: 23px;
  }

  .tablet\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .tablet\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .tablet\\:text-\\[65px\\] {
    font-size: 65px;
  }
}
  
  @media (max-width: 1140px) {

  .largeTablet\\:hidden {
    display: none;
  }

  .largeTablet\\:h-\\[128px\\] {
    height: 128px;
  }

  .largeTablet\\:w-\\[250px\\] {
    width: 250px;
  }

  .largeTablet\\:w-\\[358px\\] {
    width: 358px;
  }

  .largeTablet\\:w-auto {
    width: auto;
  }

  .largeTablet\\:flex-col {
    flex-direction: column;
  }

  .largeTablet\\:gap-2 {
    gap: 0.5rem;
  }

  .largeTablet\\:gap-\\[20\\%\\] {
    gap: 20%;
  }

  .largeTablet\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .largeTablet\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .largeTablet\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
  
  @media (max-width: 1280px) {

  .desktop\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .desktop\\:table-row {
    display: table-row;
  }

  .desktop\\:hidden {
    display: none;
  }

  .desktop\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
  
  @media (min-width: 1280px) {

  .largeScreen\\:table-row {
    display: table-row;
  }
}
  
  .rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
  
  @media (prefers-color-scheme: dark) {

  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  }

  .dark\\:bg-green-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(22 101 52 / var(--tw-bg-opacity));
  }

  .dark\\:bg-red-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(153 27 27 / var(--tw-bg-opacity));
  }

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity));
  }

  .dark\\:text-green-200 {
    --tw-text-opacity: 1;
    color: rgb(187 247 208 / var(--tw-text-opacity));
  }

  .dark\\:text-red-200 {
    --tw-text-opacity: 1;
    color: rgb(254 202 202 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}
  
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;;;AAKnB;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;;EAEvB,iBAAiB;;;AAGnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;EACV,2BAA2B;;;AAG7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,UAAU;;AAEZ;;;AAGA;EACE,sBAAsB;EACtB,WAAW;AACb;;;;;AAKA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wDAAwD;EACxD,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;;;AAGA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;AACA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,2CAA2C,EAAE;EACnD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,MAAM,2CAA2C,EAAE;EACnD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,qEAAqE;EACrE,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB,EAAE,cAAc;EACzC,cAAc;AAChB;;AAEA;EACE,qBAAqB;;;AAGvB;AACA;EACE,yBAAyB,EAAE,cAAc;;;AAG3C;AACA;EACE,qBAAqB;;AAEvB;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;AAClD;;;;AAIA;;;;;;GAMG;;AAEH;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,wEAAwE;EACxE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;;AAGA;EACE,+BAA+B,EAAE,sBAAsB;;AAEzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;EACE,WAAW;AACb;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,iBAAiB;EACrB;AACF;AACA;EACE;MACI,iBAAiB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,WAAW;AACb;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,iBAAiB;EACrB;AACF;AACA;EACE;MACI,iBAAiB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;EACA;EACA;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB,EAAE,yBAAyB;EAChD;;EAEA;IACE,qBAAqB,EAAE,mBAAmB;EAC5C;;EAEA;IACE,mBAAmB,EAAE,yBAAyB;EAChD;AACF;AACA;EACE,+BAA+B,EAAE,sBAAsB;;AAEzD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE;IACE,mBAAmB,EAAE,yBAAyB;EAChD;;EAEA;IACE,sBAAsB,EAAE,mBAAmB;EAC7C;;EAEA;IACE,qBAAqB,EAAE,yBAAyB;EAClD;AACF;;AAEA;EACE,wHAAwH;AAC1H;;AAEA,0CAA0C;;AAE1C;EACE,+BAA+B,EAAE,uDAAuD;AAC1F;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;AACA,aAAa;EACX;;;AAGF;AACA,aAAa;IACT;;EAEF;MACI,0BAA0B;MAC1B,kBAAkB;MAClB,8BAA8B;MAC9B,WAAW;MACX,YAAY;MACZ,YAAY,EACgC,WAAW;MACvD,kCAAkC;IACpC;;IAEA,WAAW;;IAMX;MACE,KAAK,uBAAuB,EAAE;MAC9B,OAAO,yBAAyB,EAAE;IACpC;;AAEJ;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,YAAY,EACgC,WAAW;EACvD,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;;2CAEuC;IAE/B,eAAe;IAEf,wBAAwB;IAChC,gCAAgC;IAChC,YAAY;EACd;EACA,eAAe,GAAG,wBAAwB,CAAC;;EAE3C;IACE,WAAW;IACX,YAAY;;IAEZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;;2CAEuC;IAE/B,eAAe;IAEf,wBAAwB;IAChC,gCAAgC;IAChC,YAAY;EACd;EACA,eAAe,GAAG,wBAAwB,CAAC;;;EAG3C;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;;EAEhB;;EAzkBF;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA,wBA2kBA;EA3kBA,wDA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,sCA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,0BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA,8BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,8BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,2GA2kBA;EA3kBA,yGA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,oBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA,8BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,kBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;EAAA,sBA2kBA;EA3kBA,8BA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,wBA2kBA;EA3kBA;AA2kBA;;EA3kBA;EAAA,mBA2kBA;EA3kBA;AA2kBA;;EA3kBA;;EAAA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,eA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,eA2kBA;IA3kBA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,4BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,0BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,uBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,6BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,8BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,qBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,qBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,6BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,6BA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,iBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,eA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,sBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,qBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,mBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,qBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA;EA2kBA;;EA3kBA;IAAA,qBA2kBA;IA3kBA;EA2kBA;AAAA;;EA3kBA;;EAAA;IAAA;EA2kBA;AAAA;;EA3kBA;EAAA;AA2kBA;;EA3kBA;;EAAA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,kBA2kBA;IA3kBA;EA2kBA;;EA3kBA;IAAA,oBA2kBA;IA3kBA;EA2kBA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Simonetta', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.swiper-button-prev {\n  height: 100% !important;\n\n  top: 0 !important;\n  \n  \n}\n\n.swiper-button-next {\n  height: 100% !important;\n  top: 0 !important;\n  right: 0 !important;\n \n}\n\n.swiper-pagination {\n  margin-top: 10px !important;\n  position: relative !important;\n}\n\n.swiper-pagination-bullet {\n  height: 12px !important;\n  width: 12px !important;\n}\n\n.swiper-pagination-bullet-active {\n  background-color: #4cadb2 !important;\n}\n\n.swiper-button-next:after {\n  font-size: 18px !important;\n  font-weight: bolder !important;\n  width: 20%;\n  color: #9a9a9add !important;\n \n\n}\n\n.swiper-button-prev:after   {\n  font-size: 18px !important;\n  font-weight: 900 !important;\n  color: #9a9a9add !important;\n  width: 20%;\n  \n}\n\n\n.swiper-button-prev, .swiper-rtl .swiper-button-next {\n  left: unset !important;\n  right: auto;\n}\n\n\n\n\n.multi-range-slider {\n  border: none !important;\n  border-radius: 0px !important;\n  box-shadow: none !important;\n}\n\n.bar-left , .bar-right {\n  padding: 4px 0px !important;\n  border: 1px solid !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n\n.face:hover {\n  animation: shake 0.3s cubic-bezier(.36,.07,.19,.97) both;\n  transform: translate3d(0, 0, 0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n\n@keyframes shake {\n  0% { transform: translate(1px, 0px) rotate(0deg); }\n  20% { transform: translate(-2px, 0px) rotate(-2deg); }\n  40% { transform: translate(1px, 0px) rotate(0deg); }\n  60% { transform: translate(-2px, 0px) rotate(-2deg); }\n  80% { transform: translate(1px, 0px) rotate(0deg); }\n  100% { transform: translate(-2px, 0px) rotate(-2deg); }\n}\n@keyframes shakeDice {\n  0% { transform: translate(1px, 0px) rotate(0deg); }\n  10% { transform: translate(1px, 0px) rotate(0deg); }\n  20% { transform: translate(-2px, 0px) rotate(-2deg); }\n  30% { transform: translate(1px, 0px) rotate(0deg); }\n  40% { transform: translate(1px, 0px) rotate(0deg); }\n  60% { transform: translate(-2px, 0px) rotate(-2deg); }\n  80% { transform: translate(1px, 0px) rotate(0deg); }\n  100% { transform: translate(-2px, 0px) rotate(-2deg); }\n}\n\n.dice:hover {\n  animation: shakeDice 0.5s cubic-bezier(.36,.07,.19,.97) both infinite;\n  transform: translate3d(0, 0, 0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n.zoom {\n\n  transition: transform .2s; /* Animation */\n  margin: 0 auto;\n}\n\n.zoom:hover {\n  transform: scale(1.1);\n\n  \n}\n.zoomImgae{\n  transition: transform .2s; /* Animation */\n\n\n}\n.zoomImgae:hover{\n  transform: scale(1.1);\n\n}\n.brand-image {\n  opacity: 1;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.fade-in {\n  opacity: 1;\n}\n\n.fade-out {\n  opacity: 0;\n}\n.active.link{\n  background-color: rgb(185 28 28 / var(--tw-bg-opacity));\n}\n\n.element-icon {\n  fill: red;\n}\n\n\n.labels {\n  display: none !important;\n}\n\n/* ImageComponent.css */\n@keyframes elementor-animation-pop {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.zoom-in-out-box {\n  transition: transform 0.3s linear;\n}\n\n.zoom-in-out-box:hover {\n  animation: elementor-animation-pop 0.3s linear 1;\n}\n\n\n\n/* .zoom-in-out-box:hover {\n  margin: 10px;\n  width: 50px;\n  height: 10px;\n\n  animation: zoom-in-zoom-out 1s ease infinite;\n} */\n\n@keyframes zoom-in-zoom-out {\n  0% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1.1, 1.1);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n.Background-fixed {\n  Background-image: url( https://www.w3schools.com/howto/img_parallax.jpg);\n  background-attachment: fixed;\n  background-position: center;\n  position: relative;\n  z-index: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.ImageInnerWrap {\n  max-width: 900px;\n  margin: 0 auto;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\n.scrol {\n  scrollbar-width: thin;\n  scrollbar-color: #6d6c6c #404040;\n}\n\n\n#img-zoom {\n  transition: transform 0.5s ease; /* Smooth transition */\n\n}\n\n.cart-background-image {\n  height: 330px !important;\n}\n\n.cart-heading {\n  background-color: rgb(0 0 0 / 0.5);\n  font-weight: 600;\n}\n\n.table-product-row {\n  font-size: 15px !important;\n}\n\n\n\n.container {\n  width: 100%;\n}\n@media (min-width: 320px) {\n  .container {\n      max-width: 400px;\n  }\n}\n@media (min-width: 512px) {\n  .container {\n      max-width: 512px;\n  }\n}\n@media (min-width: 640px) {\n  .container {\n      max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n      max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n  .container {\n      max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n  .container {\n      max-width: 1120px;\n  }\n}\n@media (min-width: 1281px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1250px;\n  }\n}\n\n\n.home {\n  width: 100%;\n}\n@media (min-width: 320px) {\n  .home {\n      max-width: 400px;\n  }\n}\n@media (min-width: 512px) {\n  .home {\n      max-width: 512px;\n  }\n}\n@media (min-width: 640px) {\n  .home {\n      max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n  .home {\n      max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n  .home {\n      max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n  .home {\n      max-width: 1120px;\n  }\n}\n@media (min-width: 1281px) {\n  .home {\n    max-width: 1340px;\n  }\n}\n@media (min-width: 1536px) {\n  .home {\n    max-width: 1250px;\n  }\n}\n@media(max-width:1100px){\n  .backgroundSetting{\n  background-size:200% 100% !important\n  }\n}\n\n#img-zoom:hover {\n  animation: zoomInOut 0.9s ease forwards infinite;\n}\n\n@keyframes zoomInOut {\n  0% {\n    transform: scale(1); /* Start at normal size */\n  }\n \n  50% {\n    transform: scale(1.2); /* Zoom in to 1.2 */\n  }\n \n  100% {\n    transform: scale(1); /* Then zoom out to 0.9 */\n  }\n}\n#icon-zoom {\n  transition: transform 0.5s ease; /* Smooth transition */\n\n}\n\n#icon-zoom:hover {\n  animation: zoomInOuticon 0.9s ease forwards infinite;\n}\n\n@keyframes zoomInOuticon {\n  0% {\n    transform: scale(1); /* Start at normal size */\n  }\n \n  50% {\n    transform: scale(1.15); /* Zoom in to 1.2 */\n  }\n \n  100% {\n    transform: scale(0.9); /* Then zoom out to 0.9 */\n  }\n}\n\n.imageChange {\n  Background-image: url( https://technostorage.nyc3.digitaloceanspaces.com/uploads/2021/11/pointing-female.png) !important;\n}\n\n/* retailerComission image hover effects */\n\n.img-hover-effect {\n  transition: transform 0.3s ease; /* Adding transition to both default and hover states */\n}\n\n.img-hover-effect:hover {\n  transform: scale(1.1) rotate(4deg);\n}\n\n.left-retailer-effect {\n  transition: transform 0.3s cubic-bezier(.47,2.02,.31,-.36);\n}\n\n.left-retailer-effect:hover {\n  transform: scale(1.2);\n}\n\n.active.link{\n  background-color: rgb(185 28 28 / var(--tw-bg-opacity));\n}\n\n.nest-wrapper  .nested-ul   ul {   \ndisplay: none;\n  } \n\n  \n.nest-wrapper:hover  .nested-ul   ul {   \ndisplay: flex;\n    }\n\n  .loader {\n      border: 16px solid #f3f3f3;\n      border-radius: 50%;\n      border-top: 16px solid #AD3511;\n      width: 50px;\n      height: 50px;\n      padding:15px;\n      -webkit-animation: spin 2s linear infinite; /* Safari */\n      animation: spin 2s linear infinite;\n    }\n    \n    /* Safari */\n    @-webkit-keyframes spin {\n      0% { -webkit-transform: rotate(0deg); }\n      100% { -webkit-transform: rotate(360deg); }\n    }\n    \n    @keyframes spin {\n      0% { transform: rotate(0deg); }\n      100% { transform: rotate(360deg); }\n    }\n\n.PLoader {\n  border: 16px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 16px solid #AD3511;\n  width: 100px;\n  height: 100px;\n  padding:15px;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 2s linear infinite;\n}\n\n.image-container {\n  position: relative;\n  overflow: hidden;\n}\n\n.image-zoom {\n  transition: transform 0.3s;\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n.image-container:hover .image-zoom {\n  transform: scale(1.5);\n  pointer-events: auto;\n}\n\n\n.buttonLoader{\n    width: 45px;\n    padding: 6px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: #ffffff;\n    --_m: \n      conic-gradient(#0000 10%,#000),\n      linear-gradient(#000 0 0) content-box;\n    -webkit-mask: var(--_m);\n            mask: var(--_m);\n    -webkit-mask-composite: source-out;\n            mask-composite: subtract;\n    animation: l3 1s infinite linear;\n    margin: auto;\n  }\n  @keyframes l3 {to{transform: rotate(1turn)}}\n\n  .Loader{\n    width: 45px;\n    padding: 6px;\n\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: #E02424;\n    --_m: \n      conic-gradient(#0000 10%,#000),\n      linear-gradient(#000 0 0) content-box;\n    -webkit-mask: var(--_m);\n            mask: var(--_m);\n    -webkit-mask-composite: source-out;\n            mask-composite: subtract;\n    animation: l3 1s infinite linear;\n    margin: auto;\n  }\n  @keyframes l3 {to{transform: rotate(1turn)}}\n\n\n  .main-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n  }\n  \n  .products-container {\n    display: grid;\n    gap: 20px;\n    justify-items: center;\n  }\n  \n  .product-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: white;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .product-image {\n    width: 100px;\n    height: 100px;\n    margin-bottom: 10px;\n  }\n  \n  .image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n  \n  .product-name {\n    font-family: \"Poppins\", Sans-serif;\n    font-size: 22px;\n    font-weight: 600;\n    text-transform: capitalize;\n    font-style: normal;\n    text-decoration: none;\n    line-height: 1.2em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n  \n  .product-price {\n    color: #1C244B;\n    font-family: \"Poppins\", Sans-serif;\n    font-size: 16px;\n    font-weight: 300;\n    text-transform: none;\n    font-style: normal;\n    text-decoration: none;\n    line-height: 1.5em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n  \n  .product-button {\n    color: #1C244B;\n    background-color: #fff0;\n    font-family: \"Poppins\", Sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: capitalize;\n    font-style: italic;\n    text-decoration: underline;\n    line-height: 1em;\n    letter-spacing: 0;\n    padding: 10px 0 0 0;\n    margin-top: 0;\n    text-align: left;\n  }\n  \n  .product-button:hover {\n    color: #467FF7;\n    \n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
